<template>
  <div>
    <hora>
      <button @click="login">Login</button>
    </hora>
  </div>
</template>

<script>
  import Hora from '@/layouts/Hora'
  import {api} from '@/axios'

  export default {
    components: {Hora},
    beforeCreate() {
      console.log('before create');
      if (this.$route.query.hasOwnProperty('rsvp')) {
        api.post('/authorize', {
          rsvp: this.$route.query.rsvp
        }).then(r => r.data)
          .then(res => {
            console.log(res);
          })
      }
    },
    methods: {
      login() {
        api.get('/authenticate')
          .then(r => r.data)
          .then(credentials => {
            console.log(credentials);
            window.location.href = credentials.url;
          })
          .catch(err => {
            this.$store.commit('ADD_ERROR', err)
          });
      }
    }
  }
</script>